export const ADD_TRANSACTION_EVENT = 'ADD_TRANSACTION_EVENT';

function transactionEventReducer (state = [], action) {
  switch (action.type) {
    case ADD_TRANSACTION_EVENT:
      return [...state, action.payload];
    default:
      return state;
  }
}

export default transactionEventReducer;




// WEBPACK FOOTER //
// ./src/storage/TransactionEventReducer.js